// extracted by mini-css-extract-plugin
export default {"userProfile":"Header_userProfile__K4PhK","active":"Header_active__+PPkX","companyName":"Header_companyName__AmFx4","email":"Header_email__yAKiw"};